import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { AppProvider, useApp } from './context/AppContext';
import theme from './theme';
import Login from './components/Login';
import Layout from './components/Layout';
import UserManagement from './components/UserManagement';
import LocationManagement from './components/LocationManagement';
import CaseManagement from './components/CaseManagement';
import SampleManagement from './components/SampleManagement';
import TraceManagement from './components/TraceManagement';
import TechnicalReport from './components/TechnicalReport';
import PhotoReport from './components/PhotoReport';
import CaseAuditLogSearch from './components/CaseAuditLogSearch';
import Statistics from './components/Statistics';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useApp();
  
  // Wait for initial load to complete before checking auth
  if (loading) {
    return null; // Or a loading spinner component
  }
  
  return currentUser ? children : <Navigate to="/" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/cases"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<CaseManagement />} />
      </Route>
      <Route
        path="/users"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<UserManagement />} />
      </Route>
      <Route
        path="/locations"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<LocationManagement />} />
      </Route>
      <Route
        path="/samples/:caseId"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<SampleManagement />} />
      </Route>
      <Route
        path="/traces/:caseId/:sampleId"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<TraceManagement />} />
      </Route>
      <Route
        path="/reports/technical/:caseId"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<TechnicalReport />} />
      </Route>
      <Route
        path="/reports/photo/:caseId"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<PhotoReport />} />
      </Route>
      <Route
        path="/audit-logs/search"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<CaseAuditLogSearch />} />
      </Route>
      <Route
        path="/statistics"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Statistics />} />
      </Route>
      {/* Catch-all route - redirect unknown paths to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <ColorModeScript 
        initialColorMode={theme.config.initialColorMode}
        storageKey="chakra-ui-color-mode"
      />
      <ChakraProvider theme={theme}>
        <AppProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AppProvider>
      </ChakraProvider>
    </>
  );
}

export default App;

